// src/components/TruthAIToken.js
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: 2rem;
  color: #b3ffce;
`;

const Title = styled.h1`
  color: #0AFF50;
  margin-bottom: 1rem;
`;

const Section = styled.div`
  margin-bottom: 1rem;

  p {
    line-height: 1.6;
    margin-bottom: 0.5rem;
  }
`;

const TruthAIToken = () => {
  return (
    <Container >
      <Title style={{marginLeft: '20px'}}>$TruthAI Token</Title>
        <span style={{marginLeft: '20px'}}>The $TruthAI token is used to fund our project and our goal to stop fake news.</span>
   
      <Section>
        <h2 style={{marginLeft: '20px'}}><br></br>How to buy</h2>
        <p style={{marginLeft: '20px'}}>
        <br></br>
          $TruthAI tokens are available for purchase on pump.fun
          <br></br>
          CA: 9t1evECofsFD8Kb7FooNV73fBj6dM8ejGa3CtVjspump
        </p>
      </Section>
    </Container>
  );
};

export default TruthAIToken;
